<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<div v-if="!stuForm.id" style="padding: 15px;">
			<van-cell-group>

				<div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
				<div style="height: 50px;"></div>
				<!-- 	<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" /> -->
				<van-field v-model="stuForm.identity_card" label="身份证号" placeholder="请输入考生身份证号" />
				<div style="height: 50px;"></div>
				<div class="submitBtn flexAround">
					<div class="btn" @click="onSearch" style="width: 40%;">查询</div>
				</div>
				<div style="height: 50px;"></div>
			</van-cell-group>
		</div>


		<div v-else>

			<van-cell-group>



				<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
					<span class="rowlabel"></span><span style="color: #fff;">*</span>基本信息
				</div>


				<van-field readonly v-model="stuForm.stu_name" label="姓名" label-width="110px" />

				<van-field readonly :value="stuForm.gender==1?'男':'女'" label="性别" label-width="110px" />
				<van-field readonly :value="stuForm.identity_card" label="身份证号" label-width="110px" />
				
				<div v-for="(item,idx) in scoreZhuanye.zy" :key="idx" style="">
					<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
						<span class="rowlabel"></span><span style="color: #fff;">*</span>专业考试
					</div>
					<van-field readonly :value="item.major_name" label="专业" label-width="110px" />
					<van-field readonly :value="item.xuezhi" label="学制" label-width="110px" />
					<van-field readonly  label="是否通过" label-width="110px" >
						<template #input>
							
							<span v-if="item.confirm==1" style="color: green;">通过</span>
							<span v-if="item.confirm==-1" style="color: orangered;">未通过</span>
						</template>
					</van-field>
				</div>
				<div v-if="scoreZhuanye.zy.length==0" style="text-align: center; line-height: 100px;">未查询到数据</div>
				<div v-for="(item,idx) in scoreZhuanye.wlt" :key="idx" style="">
					<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
						<span class="rowlabel"></span><span style="color: #fff;">*</span>文化考试
					</div>
					
					<van-field readonly  label="是否通过" label-width="110px" >
						<template #input>
							
							<span v-if="item.confirm==1" style="color: green;">通过</span>
							<span v-if="item.confirm==-1" style="color: orangered;">未通过</span>
						</template>
					</van-field>
				</div>
				<div style="height: 50px;">

				</div>
			</van-cell-group>


		</div>


	</div>




</template>

<script>
	import {
		Dialog,
		Toast
	} from 'vant';
	export default {
		components: {

		},
		data() {
			return {
				school_name: "江苏省戏剧学校",
				stuForm: {
					id: 0,
					identity_card: ""
				},
				pmid: 6,
				openid: "",
				major_id2: "",
				major_name2: "",
				fieldMajors: {
					text: 'title',
					value: 'id',
					children: 'children',
				},
				majors: [],
				showMj1: false,
				xuezhi: "",
				disabled: false,
				scoreZhuanye: {
					wlt: [],
					zy:  []
				}
			}
		},
		mounted() {
			document.title = "兼报专业报名"
			this.pmid = this.$route.query.pmid || 6
			this.openid = this.$route.query.openid

			if (this.openid) {
				this.getStudentsByOpenid()
			}

		},
		methods: {
			onSearch() {
				//alert("未到开放查询时间")
				if (!this.stuForm.identity_card) {
					Toast('请输入正确的身份证号');
				} else {
					var myreg =
						/(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
					if (!myreg.test(this.stuForm.identity_card)) {
						Toast('请输入正确的身份证号');
						return
					} else {
						this.getStudents()
					}



				}
			},
			resetForm() {
				this.stuForm = {
					id: 0,
					identity_card: ""
				}
			},
			getStudents() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					identity_card: this.stuForm.identity_card
				}).then(res => {

					if (res.data) {
						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data
						this.getStuScore()
					} else {
						Dialog.alert({
							title: '提示',
							message: '未找到报名信息！',
							theme: 'round-button',
						}).then(() => {
							// on close
						});
					}



				})
			},
			getStudentsByOpenid() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {

					if (res.data) {
						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data
						this.getStuScore()
					} else {

					}
				})
			},
			getStuScore() {
				this.$http.post("/api/xjxx_stu_score_h5", {
					stu_id: this.stuForm.stu_id,
					pmid:this.stuForm.pmid
				}).then(res => {

					this.scoreZhuanye = res.data
				})

			}

		},
	}
</script>


<style lang="less" type="text/less">


	.van-radio__icon--checked .van-icon {
  background-color: #00cfdc;
  border-color: #00cfdc;
}
	.submitBtn {
        margin-top: 2vh;
		margin-bottom: 50px;

        .btn {
            display: inline-block;
            padding: 1.4vh 8%;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
			width: 50%;
			text-align:center;
        }
		.btn:active {

		    background-color: #007AFF;

		}
    }
	.xm{ border:1px solid #ccc; display: inline-block; margin:0 10px 10px 0; padding: 4px 10px; border-radius: 4px;}
	.xmckd{ background-color: orangered; color:#fff;}
</style>
